module.exports = __webpack_public_path__ + "img/safety_notices.24868f3f.jpg";